import {
  API_BASE_URL,
} from 'src/globals';

import {
  POST,
  GET,
} from './apiHandler';
import { RATE_DIGITISATION_FETCH_ALL_RATES, RATE_DIGITISATION,
  RATE_DIGITISATION_MASTER, RATE_DIGITISATION_UPDATE_SINGLE_RATE,
  RATE_DIGITISATION_ADD_SINGLE_RATE,
  RATE_DIGITISATION_DOWNLOAD_SAMPLE_FILE_ADD,
  RATE_DIGITISATION_CREATE_BULK_REQUEST_ADD,
  RATE_DIGITISATION_DOWNLOAD_SAMPLE_FILE_EDIT,
  RATE_DIGITISATION_BULK_REQUEST_EDIT,
  RATE_DIGITISATION_DELETE_RATES,
  RATE_DIGITISATION_DOWNLOAD_RATES,
 } from './routes';

export const RateDigitisationFetchAllRates = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_FETCH_ALL_RATES}`, body);
};

export const RateDigitisationFetchMaster = async () => {
  return GET(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_MASTER}`);
};

export const rateDigitisationAddSingleRate = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_ADD_SINGLE_RATE}`, body);
};

export const rateDigitisationUpdateSingleRate = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_UPDATE_SINGLE_RATE}`, body);
};

export const downloadSampleFileAdd = async (params) => {
  return GET(`${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_DOWNLOAD_SAMPLE_FILE_ADD}`,
      params, 'blob');
};

export const rateDigitisationBulkUploadAdd = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_CREATE_BULK_REQUEST_ADD}`, body);
};

export const downloadSampleFileEdit = async (params) => {
  return GET(`${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_DOWNLOAD_SAMPLE_FILE_EDIT}`,
  params, 'blob');
};

export const rateDigitisationBulkUploadEdit = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_BULK_REQUEST_EDIT}`, body);
};

export const rateDigitisationDeleteRates = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_DELETE_RATES}`, body);
};

export const rateDigitisationDownloadRates = async (body) => {
  return GET(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_DOWNLOAD_RATES}`, body, 'blob');
};
